// extracted by mini-css-extract-plugin
module.exports = {"alertButton":"styles_alertButton__sqtrj","text":"styles_text__ij01p","icon":"styles_icon__zTWWP"};